/**
 * The catalogue returns these as regular entries, but they stand for "a value outside the
 * catalogue", so nothing can be set to them.
 */
export const cataloguePlaceholders = {
  make: 'MAKE_OTHER',
  modelFamilySuffix: '-MODELFAMILY_OTHER',
} as const;
